import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router"
@Component({
  selector: 'app-settingcomp',
  templateUrl: './settingcomp.component.html',
  styleUrls: ['./settingcomp.component.scss']
})
export class SettingcompComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit(): void {
  }
  redirectaccount():void{
    this.router.navigate(['/account'])
  }
  redirectDevice():void{
    this.router.navigate(['/devices'])
  }
}
